import { useEffect, useState } from "react";
import { LogOut } from "lucide-react";
import { Logo } from "@/components/landing/Logo";
import { adminApi } from "@/lib/adminApi";
import { AdminLogin } from "@/components/admin/AdminLogin";
import { ContentEditor } from "@/components/admin/ContentEditor";
import { InquiriesPanel } from "@/components/admin/InquiriesPanel";
import { SettingsPanel } from "@/components/admin/SettingsPanel";

const TABS = [
  { id: "content", label: "Content" },
  { id: "inquiries", label: "Inquiries" },
  { id: "settings", label: "Settings" },
];

export default function Admin() {
  const [authed, setAuthed] = useState(null); // null = checking, false = login, string = email
  const [tab, setTab] = useState("content");

  useEffect(() => {
    const token = localStorage.getItem("admin_token");
    if (!token) {
      setAuthed(false);
      return;
    }
    adminApi
      .get("/auth/me")
      .then((r) => setAuthed(r.data.email))
      .catch(() => setAuthed(false));
  }, []);

  const signOut = () => {
    localStorage.removeItem("admin_token");
    setAuthed(false);
  };

  if (authed === null) return <div className="min-h-screen bg-[#F7F6F1]" />;
  if (authed === false) return <AdminLogin onLogin={(email) => setAuthed(email)} />;

  return (
    <main data-testid="admin-dashboard" className="min-h-screen bg-[#F2F1E9] text-[#122A1D]">
      <header className="bg-white border-b border-[#122A1D]/10 px-6 lg:px-12 py-4 flex items-center justify-between sticky top-0 z-40">
        <div className="flex items-center gap-6">
          <a href="/" data-testid="admin-logo-link">
            <Logo compact />
          </a>
          <span className="text-xs uppercase tracking-[0.3em] text-[#8C6A1F] hidden sm:block">Admin CMS</span>
        </div>
        <div className="flex items-center gap-6">
          <nav className="flex gap-1">
            {TABS.map((t) => (
              <button
                key={t.id}
                data-testid={`admin-tab-${t.id}`}
                onClick={() => setTab(t.id)}
                className={`text-xs uppercase tracking-wider px-4 py-2 transition-colors ${
                  tab === t.id ? "bg-[#122A1D] text-[#E3C97A]" : "text-[#5B6F64] hover:bg-[#122A1D]/5"
                }`}
              >
                {t.label}
              </button>
            ))}
          </nav>
          <button
            onClick={signOut}
            data-testid="admin-signout-button"
            className="text-[#5B6F64] hover:text-[#A9842F] transition-colors flex items-center gap-1.5 text-xs uppercase tracking-wider"
          >
            <LogOut size={14} /> <span className="hidden sm:inline">Sign out</span>
          </button>
        </div>
      </header>

      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-10">
        {tab === "content" && <ContentEditor />}
        {tab === "inquiries" && <InquiriesPanel />}
        {tab === "settings" && <SettingsPanel />}
      </div>
    </main>
  );
}
